import { Search as SearchIcon } from '@tunasong/icons'
import type { SearchFilter as SearchFilterType } from '@tunasong/schemas'
import { HBox, TagList, disableAutocomplete, CircularProgress, TextField } from '@tunasong/ui-lib'
import type { TextFieldProps } from '@tunasong/ui-lib'
import type { ChangeEvent, FC } from 'react'

export interface SearchInputProps extends Omit<TextFieldProps, 'onChange'> {
  className?: string
  query: string
  loading: boolean
  placeholder: string
  fullWidth?: boolean
  filter?: SearchFilterType
  inputRef?: (el: HTMLElement | null) => void
  onChange(ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void
}

export const SearchInput: FC<SearchInputProps> = props => {
  const { fullWidth, placeholder, query, loading, filter, onChange, inputRef, ...restProps } = props
  const tags = [filter?.tags ?? [], filter?.types?.map(type => `type:${type}`)].filter(Boolean).flat()

  return (
    <TextField
      {...restProps}
      ref={inputRef}
      fullWidth={fullWidth}
      value={query}
      variant="standard"
      InputProps={{
        startAdornment: (
          <div
            style={{
              width: 16,
              height: '100%',
              pointerEvents: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SearchIcon />
          </div>
        ),
        endAdornment: (
          <>
            {loading ? (
              <HBox style={{ alignItems: 'center', marginRight: 8 }}>
                <CircularProgress color="inherit" size={20} />
              </HBox>
            ) : null}
            <TagList tags={tags} />
          </>
        ),
      }}
      onChange={onChange}
      placeholder={placeholder}
      inputProps={{ ...disableAutocomplete }}
      style={{
        color: 'inherit',
        backgroundColor: 'var(--tuna-palette-action-focus)',
        borderRadius: 'var(--tuna-shape-borderRadius)',
        marginBottom: 8,
        padding: '8px 8px 8px 8px',
      }}
    />
  )
}

export default SearchInput
